var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRapaNui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 13.2173V14.6086H22.7791C21.9822 15.7161 20.9207 16.6202 19.6875 17.229C19.3711 16.9003 18.9269 16.6955 18.4347 16.6955C17.6051 16.6955 16.9116 17.2767 16.7379 18.0542C16.4947 18.0755 16.2487 18.0868 16 18.0868C15.7513 18.0868 15.5052 18.0754 15.2621 18.0542C15.0884 17.2768 14.3949 16.6955 13.5652 16.6955C13.0731 16.6955 12.629 16.9003 12.3125 17.229C11.0792 16.6203 10.0179 15.716 9.22099 14.6086H11.1304V13.2173H6.26086C6.26086 18.596 10.6213 22.9564 16 22.9564C21.3788 22.9564 25.7391 18.596 25.7391 13.2173H20.8696Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRapaNui);
export default __webpack_public_path__ + "static/media/flag_rapa_nui.a71a0a4c8b65e7c70e47c1b5988c6834.svg";
export { ForwardRef as ReactComponent };